/**
 * Decorator to mark method to be bound to the instance of the class.
 */
export function Bind(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    if (!target.constructor._bindings) {
        target.constructor._bindings = [];
    }
    target.constructor._bindings.push(propertyKey);
}

/**
 * Decorator to bind all marked methods to the instance of the class.
 */
export function Bindable<T extends { new(...args: any[]): {} }>(constructor: T) {
    return class extends constructor {
        constructor(...args: any[]) {
            super(...args);
            const bindings = (constructor as any)._bindings || [];
            bindings.forEach((methodName: string) => {
                if (typeof this[methodName] === 'function') {
                    this[methodName] = this[methodName].bind(this);
                }
            });
        }
    };
}
